import { Component, Input} from '@angular/core';
import { AtInternetService } from 'src/app/services/at-internet.service';

@Component({
  selector: 'app-info-step',
  templateUrl: './info-step.component.html',
  styleUrls: ['./info-step.component.scss']
})
export class InfoStepComponent {

  @Input() list: [];
  @Input() titleBloc: string;
  @Input() imgPath: string;
  @Input() color: string;
  @Input() isAlert: boolean;
  @Input() tag;
  panelOpenState = false;

  constructor(private atInternetService: AtInternetService) { }
  isPanelOpen() {
    var width = window.outerWidth;

    if(this.isAlert && this.list.length > 1){
        return false;
    }
    if(!this.isAlert && width < 600 ) {
      return false;
    }
    return true;
  }
  generateTagIfOpen(){
    if(this.panelOpenState){
      this.atInternetService.generateClickAction(
        this.tag,
        'chevrons_details_etapes',
        'chevron_ouvert'
      );
    }
  }
}
